import React, { useEffect } from 'react';
import {
  AdvancedMarker,
  Pin,
  useAdvancedMarkerRef,
} from '@vis.gl/react-google-maps';

export default function LocationMarker({ location, isSelected, onClick, onMarkerReady }) {
  const [markerRef, marker] = useAdvancedMarkerRef();

  useEffect(() => {
    if (marker && onMarkerReady) {
      onMarkerReady(location.title, marker);
    }
  }, [marker, location.title, onMarkerReady]);

  return (
    <AdvancedMarker
      ref={markerRef}
      position={location.position}
      title={location.title}
      onClick={onClick}
    >
      <Pin
        background={isSelected ? '#0d6efd' : '#3a66bd'}
        borderColor="#fff"
        glyphColor="#fff"
      />
    </AdvancedMarker>
  );
}
